interface IFieldErrorProps {
    message?: string;
    required?: boolean;
    block?: boolean;
}

const FieldError = ({ message, required = false, block = false }: IFieldErrorProps) => (
    <>
        {required && <span className="required-marker">*</span>}
        {message && <span className="field-validation-error" style={{display: block ? 'block':'relative' }}> {message}</span>}
    </>
);

export default FieldError;
